import { BoundaryTerritoryGroupConnectedEntities } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroup.type';
import { boundaryTerritoryGroupActivate } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.actionCreators';
import type { MapSettingsToolsStateDataLayersAction } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.action';
import { setDataLayersFilter } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.actionCreators';
import type { MapSettingsToolsStateDataLayersState } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.state';

export const mapSettingsToolsStateDataLayersInitialState: MapSettingsToolsStateDataLayersState = {
  activeBTGIdPerBoundaryGroup: {},
  filters: {},
};

type Action = MapSettingsToolsStateDataLayersAction | ReturnType<typeof boundaryTerritoryGroupActivate>;

export const mapSettingsToolsStateDataLayersReducer = (state = mapSettingsToolsStateDataLayersInitialState, action: Action): MapSettingsToolsStateDataLayersState => {
  if (setDataLayersFilter.match(action)) {
    const { boundaryGroupId, filter } = action.payload;

    return {
      ...state,
      filters: {
        ...state.filters,
        [boundaryGroupId]: filter,
      },
    };
  }

  if (boundaryTerritoryGroupActivate.match(action)) {
    const { activeBTG: { boundaryGroupId, boundaryTerritoryGroupId, settings: { connectedEntityData } } } = action.payload;

    if (connectedEntityData?.entity !== BoundaryTerritoryGroupConnectedEntities.DataLayer) {
      return state;
    }

    return {
      ...state,
      activeBTGIdPerBoundaryGroup: {
        ...state.activeBTGIdPerBoundaryGroup,
        [boundaryGroupId]: boundaryTerritoryGroupId,
      },
    };
  }

  return state;
};
